import * as React from "react"

export default function NearbySolidIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.243 11.575L8 15.817l-4.243-4.242a6 6 0 118.486 0zM8 9.999a2.667 2.667 0 100-5.334A2.667 2.667 0 008 10zm0-1.334A1.333 1.333 0 118 6a1.333 1.333 0 010 2.666z"
        fill={props.fill}
      />
    </svg>
  )
}


